{
  "summary": {
    "title": "Executive summary with AI",
    "subtitle": "Generated by Claude · only this project's context",
    "last_n_days": "Last {n} days",
    "regenerate": "Regenerate",
    "analyzing": "Analyzing activity…",
    "error": "Couldn't generate the summary.",
    "stat_completed": "Completed",
    "stat_created": "Created",
    "stat_comments": "Comments",
    "disclaimer": "AI can make mistakes. Verify critical data."
  }
}
